import 'css-chunksrc/client/scenes/resourceEdition/allocationManagement/styles.scss';export default {
  "allocationManagement": "_allocationManagement_kt7pn_1",
  "resourceForm": "_resourceForm_kt7pn_10",
  "addAllocation": "_addAllocation_kt7pn_14",
  "list": "_list_kt7pn_19",
  "iconBox": "_iconBox_kt7pn_25",
  "icon": "_icon_kt7pn_25",
  "title": "_title_kt7pn_37",
  "allocationList": "_allocationList_kt7pn_41",
  "resources": "_resources_kt7pn_45",
  "resource": "_resource_kt7pn_10",
  "clearButton": "_clearButton_kt7pn_56"
};